"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const wrapper = require('./WrapperWrapper');
var CryptoUtils;
(function (CryptoUtils) {
    function generateSaltForPwHash() {
        return __awaiter(this, void 0, void 0, function* () {
            const s = yield wrapper.salt();
            return s;
        });
    }
    CryptoUtils.generateSaltForPwHash = generateSaltForPwHash;
    function encryptMessage(message, passphrase, salt) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyBytes = yield wrapper.pwhash(passphrase, salt);
            const n = yield wrapper.nonce();
            const nonce = Buffer.from(n);
            const s = yield wrapper.close(message, nonce, keyBytes);
            const cipherText = Buffer.from(s);
            return Buffer.concat([nonce, cipherText]);
        });
    }
    CryptoUtils.encryptMessage = encryptMessage;
    function decryptMessage(message, passphrase, salt) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyBytes = yield wrapper.pwhash(passphrase, salt);
            const m = yield wrapper.open(message, keyBytes);
            return Buffer.from(m);
        });
    }
    CryptoUtils.decryptMessage = decryptMessage;
    function generateKeys(seed) {
        return __awaiter(this, void 0, void 0, function* () {
            const k = yield wrapper.keys(seed);
            return { secretKey: k.privateKey, publicKey: k.publicKey };
        });
    }
    CryptoUtils.generateKeys = generateKeys;
    function recoverPublicKey(secretKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const k = yield wrapper.publicKey(secretKey);
            return { secretKey: k.privateKey, publicKey: k.publicKey };
        });
    }
    CryptoUtils.recoverPublicKey = recoverPublicKey;
    function signDetached(payload, secretKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const b = yield wrapper.sign(payload, secretKey);
            return Buffer.from(b);
        });
    }
    CryptoUtils.signDetached = signDetached;
    function checkSignature(signature, payload, publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield wrapper.checkSignature(signature, payload, publicKey);
        });
    }
    CryptoUtils.checkSignature = checkSignature;
})(CryptoUtils = exports.CryptoUtils || (exports.CryptoUtils = {}));
//# sourceMappingURL=CryptoUtils.js.map